let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("bd0WN")).then(() => parcelRequire('b5voN'));